import React from 'react'
import store from '../Components/StateHandler'
import { categories, statuses, defaultStatus } from './data'

const customStore = store({ 
    categories,
    statuses,
    currentStatus: defaultStatus,
    categoryTooltipId: 2,
    step: 0
 }) 

function Wrapper(InnerComponent) {
    class Provider extends React.Component {
        getStatusByCategory(id) {
            return this.props.statuses.filter(status => status.category === id);
        }

        getStatusById(id) {
            return this.props.statuses.find(status => status.id === id);
        }

        getCurrentStatus() {
            return this.props.statuses.find(status => status.id === this.props.currentStatus);
        }

        getCategoryById(id) {
            return this.props.categories.find(category => category.id === id);
        }

        render() {
            return (
                <InnerComponent
                    {...this.props}
                    getStatusByCategory={this.getStatusByCategory.bind(this)}
                    getStatusById={this.getStatusById.bind(this)}
                    getCurrentStatus={this.getCurrentStatus.bind(this)}
                    getCategoryById={this.getCategoryById.bind(this)}
                />
            );
        }
    }

    return customStore(Provider);
}

export default Wrapper